<template>
  <v-bottom-navigation
    :value="true"
    app
    :shift="!bigEnough"
    grow
    >
    <Bottomicons v-for="nav in navs" :key="nav.value" :nav="nav"></Bottomicons>
  </v-bottom-navigation>
</template>

<script>
import Bottomicons from '@/components/Bottomicons'
export default {
  components: {
    Bottomicons
  },
  computed: {
    bigEnough () {
      return this.$vuetify.breakpoint.smAndUp
    }
  },
  name: 'app-bottom',
  data: () => ({
    navs: [{
      value: 'films',
      itemtype: 'film'
    }, {
      value: 'people',
      itemtype: 'person'
    }, {
      value: 'companies',
      itemtype: 'company'
    }, {
      value: 'brands',
      itemtype: 'brand'
    }, {
      value: 'products',
      itemtype: 'product'
    }, {
      value: 'awards',
      itemtype: 'award'
    }]
  })
}
</script>
